import {
  addAssetType,
  getAllAssetsTypes,
} from "../../../Redux/Assets/AssetsActions";
import validator, { ValidationField } from "../../../Util/validator";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import { Link, useNavigate } from "react-router";
import styles from "./AddAssetType.module.scss";
import { useEffect, useState } from "react";

function AddAssetType() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { addAssetTypeLoading, assetTypesLoading, assetTypesData } =
    useSelector((state: RootState) => state.assets);

  const [type, setType] = useState<string>("");
  const [parentTypeId, setParentTypeId] = useState<string>("");

  const [errors, setErrors] = useState<{
    type: string;
    parentTypeId: string;
  }>({
    type: "",
    parentTypeId: "",
  });

  const addAssetTypeHandler = () => {
    const fields: ValidationField[] = [
      {
        key: "type",
        type: "text",
        value: type,
      },
    ];

    const { errors: fieldErrors, isValid } = validator(fields);
    setErrors({ ...errors, ...fieldErrors });

    if (isValid) {
      if (!addAssetTypeLoading) {
        const successHandler = () => {
          navigate("/admin/assets", {
            replace: true,
          });
        };

        dispatch(
          addAssetType({
            type,
            parentTypeId: parentTypeId ? parseInt(parentTypeId) : null,
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    dispatch(getAllAssetsTypes());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.mainContainer}>
      <Link to="/admin/assets" replace className={styles.backButtonContainer}>
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Assets
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Add Asset Type</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Type</p>
          <input
            type="text"
            className={styles.input}
            value={type}
            onChange={(e) => setType(e.target.value)}
          />
          <p className={styles.error}>{errors.type}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Parent Type</p>
          <select
            className={styles.input}
            value={parentTypeId}
            onChange={(e) => setParentTypeId(e.target.value)}
          >
            <option value="">None</option>
            {assetTypesData?.map((assetType, i) => (
              <option key={i} value={assetType?.assetTypeId}>
                {assetType?.type}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.parentTypeId}</p>
        </div>

        {(addAssetTypeLoading || assetTypesLoading) && <Loading />}

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={addAssetTypeHandler}>
            Add Asset Type
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddAssetType;
